import React from 'react'

import { ProductIds } from 'core/application/commons/config'

import useCurrentProduct from '../../common/hooks/useCurrentProduct'
import GcHraHome from './groupHra'
import IchraHome from './ichra'
import PerksHome from './perks'
import QsehraHome from './qsehra'

import './groupHra/Home.less'

const productSignupMap = new Map<number, any>()
productSignupMap.set(ProductIds.GroupHraId, <GcHraHome />)
productSignupMap.set(ProductIds.Perks, <PerksHome />)
productSignupMap.set(ProductIds.QsehraId, <QsehraHome />)
productSignupMap.set(ProductIds.IchraId, <IchraHome />)

const AdminDashboardHome: React.FC = () => {
  const product = useCurrentProduct()
  return <div data-testid={'admin-dashboard'}>{productSignupMap.get(product.productId)}</div>
}

export default AdminDashboardHome
